var $0d593fbbaf6b5741$exports = {};
$0d593fbbaf6b5741$exports = {
    "loading": `Chargement...`,
    "loadingMore": `Chargement suppl\xe9mentaire...`
};


export {$0d593fbbaf6b5741$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
